import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Filter = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 24 24"
      fill={fill}
      {...rest}
    >
      <g>
        <path fill="none" d="M0 0H24V24H0z" transform="translate(3.999 3) translate(-3.999 -3)" />
        <g>
          <path
            d="M17.6 0h-16a.8.8 0 0 0-.8.8v2.4a.8.8 0 0 0 .234.565L7.2 9.931V18.4a.8.8 0 0 0 1.28.64l3.2-2.4A.8.8 0 0 0 12 16V9.931l6.166-6.166A.8.8 0 0 0 18.4 3.2V.8a.8.8 0 0 0-.8-.8z"
            transform="translate(3.999 3) translate(-1.801 -1)"
          />
        </g>
      </g>
    </svg>
  );
};

Filter.displayName = 'Filter';
